import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "defect-review-container" }
const _hoisted_2 = { class: "defect-review-content" }
const _hoisted_3 = { class: "left-panel" }
const _hoisted_4 = { class: "right-body" }
const _hoisted_5 = { class: "tree-wrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "node-arrow" }
const _hoisted_8 = { class: "node-label" }
const _hoisted_9 = {
  key: 0,
  class: "tree-children"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "child-label" }
const _hoisted_12 = { class: "right-panel" }
const _hoisted_13 = { class: "card-grid" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "card-text-wrap" }
const _hoisted_17 = { class: "card-text" }
const _hoisted_18 = { class: "preview-content" }
const _hoisted_19 = { class: "preview-body" }
const _hoisted_20 = { class: "preview-card" }
const _hoisted_21 = { class: "preview-main" }
const _hoisted_22 = { class: "preview-nav-side" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "preview-nav-side" }
const _hoisted_25 = { class: "preview-zoom-actions" }

import { computed, onBeforeMount, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import ReviewHeader from '@/components/modules/reviewHeader/index.vue'
import testTowerImage from '@/assets/images/test_tower_image.png'
import {useStore} from 'vuex'
import {$config, $enum} from '@/global/index'
import { getDeviceDefectGallery, getDeviceDefectTree } from '@/service'

interface ITreeChild {
  id: string
  label: string
}

interface ITreeNode {
  id: string
  label: string
  children: ITreeChild[]
}

interface IDefectCard {
  id: string
  label: string
  categoryId: string
  childId: string
  image: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const store = useStore()
const isSearchHover = ref(false)
const isSearchFocus = ref(false)
const searchKeyword = ref('')
const isPreviewVisible = ref(false)
const currentPreviewIndex = ref(0)
const scale = ref(1)
const dragging = ref(false)
const offsetX = ref(0)
const offsetY = ref(0)
const startX = ref(0)
const startY = ref(0)
const previewImageRef = ref<HTMLImageElement | null>(null)
const sceneTypeId = ref(store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id)

const treeData = ref<ITreeNode[]>([])
const expandedNodeIds = ref<Set<string>>(new Set())
const activeNodeId = ref('')
const activeChildId = ref('')
const allCards = ref<IDefectCard[]>([])

const searchStateClass = computed(() => {
  if (isSearchFocus.value || isSearchHover.value) return 'is-hover'
  if (searchKeyword.value.trim()) return 'is-filled'
  return 'is-default'
})

const filteredCards = computed(() => allCards.value)

const groupedCards = computed(() => {
  const result: IDefectCard[][] = []
  for (let i = 0; i < filteredCards.value.length; i += 3) {
    result.push(filteredCards.value.slice(i, i + 3))
  }
  return result
})

const currentTreeLabel = computed(() => {
  const node = treeData.value.find((item) => item.id === activeNodeId.value)
  if (!node) return ''
  const child = node.children.find((item) => item.id === activeChildId.value)
  return child?.label || node.label
})

const currentPreviewCard = computed(() => filteredCards.value[currentPreviewIndex.value] || null)
const canPreviewPrev = computed(() => currentPreviewIndex.value > 0)
const canPreviewNext = computed(() => currentPreviewIndex.value < filteredCards.value.length - 1)
const scalePercentage = computed(() => Math.round(scale.value * 100))

const previewHeaderTitle = computed(() => {
  return `${currentTreeLabel.value}/${currentPreviewCard.value?.label || ''}`
})

const imageStyle = computed(() => ({
  transform: `translate(${offsetX.value}px, ${offsetY.value}px) scale(${scale.value})`,
  cursor: dragging.value ? 'grabbing' : 'grab',
}))

const getImageUrl = (url: string) => {
  if (!url) return 
  const base = $config.FILE_ROOT_PATH || ''
  return `${base}${url}`
}

watch(filteredCards, (newValue) => {
  if (!newValue.length) {
    isPreviewVisible.value = false
    currentPreviewIndex.value = 0
    return
  }
  if (currentPreviewIndex.value > newValue.length - 1) {
    currentPreviewIndex.value = newValue.length - 1
  }
})

watch(currentPreviewIndex, () => {
  resetImage(true)
})

function handleBack() {
  router.back()
}

function closePreview() {
  isPreviewVisible.value = false
}

function toggleNode(nodeId: string) {
  if (expandedNodeIds.value.has(nodeId)) {
    expandedNodeIds.value.delete(nodeId)
  } else {
    expandedNodeIds.value.add(nodeId)
  }
  // 点击父节点时仅切换展开/收起，不改变当前已选子节点与右侧内容
}

function handleSelectChild(nodeId: string, childId: string) {
  activeNodeId.value = nodeId
  activeChildId.value = childId
  getGalleryData(childId)
}

function handleSearchClick() {
  getTreeData(searchKeyword.value.trim())
}

function handleCardClick(card: IDefectCard) {
  const index = filteredCards.value.findIndex((item) => item.id === card.id)
  if (index === -1) return
  currentPreviewIndex.value = index
  isPreviewVisible.value = true
}

function previewPrev() {
  if (!canPreviewPrev.value) return
  currentPreviewIndex.value -= 1
}

function previewNext() {
  if (!canPreviewNext.value) return
  currentPreviewIndex.value += 1
}

function startDrag(event: MouseEvent) {
  const target = event.target as HTMLElement | null
  if (target && !target.classList.contains('draggable-image')) return
  dragging.value = true
  startX.value = event.clientX - offsetX.value
  startY.value = event.clientY - offsetY.value
}

function doDrag(event: MouseEvent) {
  if (!dragging.value) return
  offsetX.value = event.clientX - startX.value
  offsetY.value = event.clientY - startY.value
}

function stopDrag() {
  dragging.value = false
}

function zoom(event: WheelEvent) {
  const imageEl = previewImageRef.value
  if (!imageEl) return

  const rectBefore = imageEl.getBoundingClientRect()
  const isCursorOnImage =
    event.clientX >= rectBefore.left &&
    event.clientX <= rectBefore.right &&
    event.clientY >= rectBefore.top &&
    event.clientY <= rectBefore.bottom

  // 鼠标必须落在图片本体上，空白区域滚轮不触发缩放
  if (!isCursorOnImage) return

  event.preventDefault()
  const delta = event.deltaY < 0 ? 0.1 : -0.1
  const nextScale = Math.max(0.25, Math.min(scale.value + delta, 10))
  if (nextScale === scale.value) return

  const oldScale = scale.value
  const zoomFactor = nextScale / oldScale

  const pointRatioX = (event.clientX - rectBefore.left) / rectBefore.width
  const pointRatioY = (event.clientY - rectBefore.top) / rectBefore.height

  const centerX = rectBefore.left + rectBefore.width / 2
  const centerY = rectBefore.top + rectBefore.height / 2
  const widthAfter = rectBefore.width * zoomFactor
  const heightAfter = rectBefore.height * zoomFactor
  const leftAfter = centerX - widthAfter / 2
  const topAfter = centerY - heightAfter / 2

  const pointAfterX = leftAfter + widthAfter * pointRatioX
  const pointAfterY = topAfter + heightAfter * pointRatioY

  offsetX.value += event.clientX - pointAfterX
  offsetY.value += event.clientY - pointAfterY
  scale.value = nextScale
}

function zoomIn() {
  const next = scale.value + 0.5
  scale.value = Math.max(0.25, Math.min(next, 10))
}
function zoomOut() {
  const next = scale.value - 0.5
  scale.value = Math.max(0.25, Math.min(next, 10))
}

function resetImage(silent = false) {
  scale.value = 1
  offsetX.value = 0
  offsetY.value = 0
  if (silent) return
}

async function getTreeData(keyword?: string) {
  const params = {
    sceneTypeId: sceneTypeId.value,
    keyword: keyword || '',
  }
  const { code, data } = await getDeviceDefectTree(params)
  if (code !== $enum.EnumResult.SUCCESS) {
    treeData.value = []
    allCards.value = []
    activeNodeId.value = ''
    activeChildId.value = ''
    return
  }
  const parts = Array.isArray(data?.parts) ? data.parts : []
  treeData.value = parts.map((part: any) => ({
    id: String(part?.id || ''),
    label: part?.name || '',
    children: (Array.isArray(part?.positions) ? part.positions : []).map((position: any) => ({
      id: String(position?.id || ''),
      label: position?.name || '',
    })),
  }))

  const defaultPositionId = String(data?.defaultPositionId || '')
  const defaultNode = treeData.value.find((node) =>
    node.children.some((child) => child.id === defaultPositionId)
  )
  const firstNode = treeData.value[0]
  const targetNode = defaultNode || firstNode
  const targetChildId =
    defaultPositionId && targetNode?.children.some((child) => child.id === defaultPositionId)
      ? defaultPositionId
      : targetNode?.children?.[0]?.id || ''

  activeNodeId.value = targetNode?.id || ''
  activeChildId.value = targetChildId
  expandedNodeIds.value = new Set(targetNode?.id ? [targetNode.id] : [])

  if (targetChildId) {
    await getGalleryData(targetChildId)
  } else {
    allCards.value = []
  }
}

async function getGalleryData(positionId: string) {
  const params = {
    sceneTypeId: sceneTypeId.value,
    positionId,
  }
  const { code, data } = await getDeviceDefectGallery(params)
  if (code !== $enum.EnumResult.SUCCESS) {
    allCards.value = []
    return
  }
  const items = Array.isArray(data?.items) ? data.items : []
  allCards.value = items.map((item: any) => ({
    id: String(item?.id || ''),
    label: item?.name || '',
    categoryId: activeNodeId.value,
    childId: String(positionId),
    image: item?.imageUrl || testTowerImage,
  }))
}

onBeforeMount(() => {
  getTreeData('')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReviewHeader, {
      class: "defect-review-header",
      title: "缺陷认识",
      onBack: handleBack
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "right-title" }, "设备部位", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["search-input-wrap", searchStateClass.value]),
            onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (isSearchHover.value = true)),
            onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isSearchHover.value = false))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              type: "text",
              class: "search-input",
              placeholder: "请输入内容",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocus.value = true)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocus.value = false)),
              onKeyup: _withKeys(handleSearchClick, ["enter"])
            }, null, 544), [
              [_vModelText, searchKeyword.value]
            ]),
            _createElementVNode("button", {
              class: "search-btn",
              type: "button",
              onClick: handleSearchClick,
              "aria-label": "search"
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "search-icon" }, null, -1)
            ]))
          ], 34),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeData.value, (node) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tree-node",
                key: node.id
              }, [
                _createElementVNode("div", {
                  class: "tree-node-row",
                  onClick: ($event: any) => (toggleNode(node.id))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(expandedNodeIds.value.has(node.id) ? '▾' : '▸'), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(node.label), 1)
                ], 8, _hoisted_6),
                (expandedNodeIds.value.has(node.id) && node.children?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.children, (child) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: child.id,
                          class: _normalizeClass(["tree-child-row", { active: child.id === activeChildId.value }]),
                          onClick: _withModifiers(($event: any) => (handleSelectChild(node.id, child.id)), ["stop"])
                        }, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(child.label), 1)
                        ], 10, _hoisted_10))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedCards.value, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-row",
              key: `row-${rowIndex}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "defect-card",
                  key: item.id,
                  onClick: ($event: any) => (handleCardClick(item))
                }, [
                  _createElementVNode("img", {
                    class: "card-image",
                    src: getImageUrl(item.image),
                    alt: item.label
                  }, null, 8, _hoisted_15),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(item.label), 1)
                  ])
                ], 8, _hoisted_14))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      _createVNode(ReviewHeader, {
        class: "preview-header",
        title: previewHeaderTitle.value,
        onBack: closePreview
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: _normalizeClass(["preview-nav-btn", { disabled: !canPreviewPrev.value }]),
                onClick: previewPrev
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "iconfont-line vk_djtz_line" }, null, -1)
              ]), 2)
            ]),
            _createElementVNode("div", {
              class: "preview-image-box",
              ref: "mainImageWrapper",
              onWheel: zoom,
              onMousedown: startDrag,
              onMousemove: doDrag,
              onMouseup: stopDrag,
              onMouseleave: stopDrag
            }, [
              (currentPreviewCard.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    ref_key: "previewImageRef",
                    ref: previewImageRef,
                    draggable: "false",
                    src: getImageUrl(currentPreviewCard.value.image),
                    class: "preview-image draggable-image",
                    style: _normalizeStyle(imageStyle.value)
                  }, null, 12, _hoisted_23))
                : _createCommentVNode("", true)
            ], 544),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: _normalizeClass(["preview-nav-btn", { disabled: !canPreviewNext.value }]),
                onClick: previewNext
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "iconfont-line vk_djty_line" }, null, -1)
              ]), 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: "zoom-btn",
              onClick: zoomOut
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "iconfont-line vk_sx_line" }, null, -1)
            ])),
            _createElementVNode("div", {
              class: "zoom-percent",
              onClick: resetImage
            }, _toDisplayString(scalePercentage.value) + "%", 1),
            _createElementVNode("div", {
              class: "zoom-btn",
              onClick: zoomIn
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "iconfont-line vk_fd_line" }, null, -1)
            ]))
          ])
        ])
      ])
    ], 512), [
      [_vShow, isPreviewVisible.value]
    ])
  ]))
}
}

})